import { TRUNCATED_PATH_PLACEHOLDER } from "src/components/SegmentPicker/components/ListItemBreadcrumb/constants"
import { PathPair } from "src/components/SegmentPicker/components/ListItemBreadcrumb/types"

/**
 * Clean function to truncate path parts, keeping first and last with ellipsis
 */
export function truncatePathParts(parts: PathPair[]): PathPair[] {
    return parts.length > 2
        ? [
              parts[0],
              { path: TRUNCATED_PATH_PLACEHOLDER, index: -1 },
              parts[parts.length - 1],
          ]
        : parts
}
